import './App.scss';
import { Routes, Route } from 'react-router-dom';
import MainPage from './Components/MainPage';
import ProductPage from './Components/ProductPage/ProductPage';
import productsData from './productsData';

function App() {
    return (
        <>
            <Routes>
                <Route path='/' exact element={<MainPage />} />
                <Route path='/productPage' exact element={<ProductPage />} />

                {productsData.map((product) => (
                    <Route
                        key={product.productId}
                        path={`product/${product.productName
                            .split(' ')
                            .join('')}/${product.productId}`}
                        exact
                        element={
                            <ProductPage
                                productName={product.productName}
                                productPrice={product.productPrice}
                                image1={product.image}
                                renderSuggested={true}
                                link={`product/${product.productName
                                    .split(' ')
                                    .join('')}/${product.productId}`}
                            />
                        }
                    />
                ))}
            </Routes>
        </>
    );
}

export default App;
